import { FlexBox } from '@airship-platform/jam-web/components';
import Chip from '@mui/material/Chip';
import { AppointmentHistory } from '../../../../data-access/appointmentHistory';
import ProposalEngagementChip from './ProposalEngagementChip';

const statusLabels: Record<AppointmentHistory['status'], string> = {
  SCHEDULED: 'Scheduled',
  DISPATCHED: 'Dispatched',
  'IN-PROGRESS': 'Working',
  COMPLETED: 'Done',
  'ON-HOLD': 'On Hold',
  CANCELLED: 'Cancelled',
};

interface AppointmentSearchListChipsProps {
  appointment: AppointmentHistory;
}

const AppointmentSearchListChips: React.FC<AppointmentSearchListChipsProps> = ({
  appointment,
}) => {
  const renderOpportunityChip = (hasOldOptions: boolean) => (
    <Chip
      color={hasOldOptions ? 'softBlue' : 'softGreen'}
      label={hasOldOptions ? 'Won' : 'Open opportunity'}
      size={'small'}
    />
  );

  const sharedProposal = appointment.proposals.find((p) => p.hasBeenShared);

  return (
    <FlexBox gap={1} alignItems={'center'} flexWrap={'wrap'}>
      <Chip
        label={statusLabels[appointment.status]}
        size="small"
        color="softBlue"
        sx={{ minWidth: 140 }}
      />

      {renderOpportunityChip(
        appointment.proposals.some((p) => p.hasSoldOption)
      )}

      {sharedProposal ? (
        <ProposalEngagementChip
          appointmentProposalId={sharedProposal.appointmentProposalId}
        />
      ) : (
        <Chip color={'softRed'} label={'Proposal not shared'} size={'small'} />
      )}
    </FlexBox>
  );
};

export default AppointmentSearchListChips;
